<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-lg [header]="'Direct'">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main
    *ngIf="directSubscription$ | async as sub"
    fxFlex
    class="subnav__exists"
    [ngClass.lt-lg]="{ mobile: true }"
    fxLayout="column"
    fxLayoutGap="40px">
    <ng-container *ngIf="payoutMethods$ | async as payoutMethods; else loading">
      <app-feature-flag-tabs>
        <sbnb-page-header class="!mb-0" navTabs>
          <div class="flex w-full justify-between">
            <h2 class="nomargin flex-1 text-center sbnbDesktop:text-left mb-0">Payout Methods</h2>
            <sbnb-button
              class="absolute right-0 sbnbDesktop:relative"
              size="mini"
              (clicked)="addPaymentMethod(sub.plan)">
              +
              <span class="hidden sbnbDesktop:inline-block">&nbsp;Add new</span>
            </sbnb-button>
          </div>
        </sbnb-page-header>

        <div class="flex w-full justify-between">
          <h2 class="nomargin flex-1">Payout Methods</h2>
          <sbnb-button size="mini" (clicked)="addPaymentMethod(sub.plan)">+ Add new</sbnb-button>
        </div>
      </app-feature-flag-tabs>

      <div class="payout-methods-nova">
        <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'direct-payout-methods'"></sbnb-helptext-wrapper>
        <sbnb-helptext-wrapper [area]="'content'" [pageId]="'direct-payout-methods'"></sbnb-helptext-wrapper>
      </div>

      <sbnb-no-items
        *ngIf="!payoutMethods?.length"
        text="Get paid for your Direct bookings"
        subtext="To get paid for your Direct bookings, we'll need to know how to process your payments. Add your first payout method now to start receiving bookings and payments from guests."
        [buttons]="[{ id: 'new', label: 'Add your first payout method', size: 'small' }]"
        (button)="addPaymentMethod(sub.plan)"></sbnb-no-items>

      <div *ngIf="payoutMethods?.length > 0">
        <ng-container *ngIf="!(isMobile$ | async); else mobileItems">
          <div fxLayout fxLayoutGap="19px" class="rules__rule-header">
            <div fxFlex>Name</div>
            <div fxFlex="100px">Plan</div>
            <div fxFlex="100px">Properties</div>
            <div fxFlex="160px">Status</div>
            <div fxFlex="160px"></div>
            <div fxFlex="20px"></div>
          </div>

          <a
            *ngFor="let payout of payoutMethods"
            fxLayout
            fxLayoutAlign.lt-lg="start start"
            class="rules__rule-container"
            [class.not-current-plan]="sub.plan !== (payout.provider === 'adyen' ? 'direct-premium' : 'direct-basic')"
            fxLayoutAlign="start center"
            fxLayoutGap="19px"
            [matTooltip]="
              sub.plan !== (payout.provider === 'adyen' ? 'direct-premium' : 'direct-basic')
                ? 'This payout method is not currently in use as it does not match your Direct plan.'
                : null
            "
            (click)="updatePayoutMethod(payout)">
            <div fxLayout="column" fxFlex>
              <span class="rule__title ellipsis">
                {{ payout | payoutMethodTitle }}
                <span *ngIf="payout.adyen.bank_account_number && !payout.name">
                  (x{{ payout.adyen.bank_account_number }})
                </span>
              </span>
              <span class="text__small smoke-darker ellipsis">
                {{ payout | payoutMethodSubtitle }}
                <span *ngIf="payout.adyen.bank_account_number && payout.name">
                  (x{{ payout.adyen.bank_account_number }})
                </span>
              </span>

              <sbnb-cs-debug-item
                *ngIf="payout.adyen.account_holder_id"
                class="text__small"
                label="Account Holder ID"
                [value]="payout.adyen.account_holder_id"
                [link]="
                  'https://balanceplatform-live.adyen.com/balanceplatform/accounts/account-holders/' +
                  payout.adyen.account_holder_id
                "
                (click)="$event.stopPropagation()"></sbnb-cs-debug-item>
            </div>

            <div
              class="text__small payout-method-plan"
              fxFlex="100px"
              fxFlex.lt-lg="none"
              fxLayoutAlign="start center"
              fxLayoutGap="8px">
              {{ payout.provider === 'adyen' ? 'Premium' : 'Basic' }}
            </div>

            <div fxFlex="100px" fxFlex.lt-lg="none" fxLayoutAlign="start center" fxLayoutGap="8px">
              <sbnb-avatar-group
                [items]="payout.property_list"
                [allItems]="payout.all_properties"
                allItemsLabel="Default"
                [itemsForLabel]="payout | payoutMethodTitle"></sbnb-avatar-group>
            </div>

            <div fxFlex="160px" fxFlex.lt-lg="none" fxLayout="column">
              <sbnb-direct-payout-method-status
                [payout]="payout"
                (verificationClicked)="verifyClicked(payout.uuid)"></sbnb-direct-payout-method-status>
            </div>

            <div
              fxFlex="160px"
              fxFlex.lt-lg="none"
              fxLayout
              fxLayout.lt-lg="column"
              fxLayoutAlign="end center"
              fxLayoutGap="6px">
              <sbnb-button
                *ngIf="payout.adyen?.kyc_required"
                size="mini"
                type="primary"
                label="Verify"
                (click)="$event.stopPropagation()"
                (clicked)="verifyClicked(payout.uuid)"></sbnb-button>
              <!-- <sbnb-button
                *ngIf="payout.adyen?.status === AdyenPayoutMethodStatus.VALID && payout.adyen?.missing_tin"
                size="mini"
                type="primary"
                label="Add taxpayer information"
                (click)="$event.stopPropagation()"
                (clicked)="addTaxInformation(payout.uuid)"></sbnb-button> -->
            </div>

            <div fxFlex="20px">
              <sbnb-more-menu-trigger
                *ngIf="payout.can_delete && !payout.all_properties"
                [matMenuTriggerFor]="actionsMenu"
                [suppressClick]="true"></sbnb-more-menu-trigger>
              <mat-menu #actionsMenu="matMenu">
                <button mat-menu-item (click)="deletePayoutMethodPrompt(payout)">Delete</button>
              </mat-menu>
            </div>
          </a>
        </ng-container>

        <!-- Mobile items-->
        <ng-template #mobileItems>
          <div fxLayout fxLayoutGap="19px" class="rules__rule-header">
            <div fxFlex>Payout Method</div>
          </div>
          <a
            *ngFor="let payout of payoutMethods"
            fxLayout="column"
            fxLayoutGap="8px"
            class="rules__rule-container"
            [class.not-current-plan]="sub.plan !== (payout.provider === 'adyen' ? 'direct-premium' : 'direct-basic')"
            [matTooltip]="
              sub.plan !== (payout.provider === 'adyen' ? 'direct-premium' : 'direct-basic')
                ? 'This payout method is not currently in use as it does not match your Direct plan.'
                : null
            "
            (click)="updatePayoutMethod(payout)">
            <div class="mobile-main-row" fxLayout fxLayoutGap="12px">
              <div fxLayout="column" fxFlex>
                <span class="rule__title ellipsis">
                  {{ payout | payoutMethodTitle }}
                  <span *ngIf="payout.adyen.bank_account_number && !payout.name">
                    (x{{ payout.adyen.bank_account_number }})
                  </span>
                </span>
                <span class="text__small smoke-darker ellipsis">
                  {{ payout | payoutMethodSubtitle }}
                  <span *ngIf="payout.adyen.bank_account_number && payout.name">
                    (x{{ payout.adyen.bank_account_number }})
                  </span>
                </span>
              </div>

              <div fxFlex="20px">
                <sbnb-more-menu-trigger
                  *ngIf="payout.can_delete && !payout.all_properties"
                  [matMenuTriggerFor]="actionsMenu"
                  [suppressClick]="true"></sbnb-more-menu-trigger>
                <mat-menu #actionsMenu="matMenu">
                  <button mat-menu-item (click)="deletePayoutMethodPrompt(payout)">Delete</button>
                </mat-menu>
              </div>

              <div
                fxFlex="160px"
                fxFlex.lt-lg="none"
                fxLayout
                fxLayout.lt-lg="column"
                fxLayoutAlign="end center"
                fxLayoutGap="6px">
                <sbnb-button
                  *ngIf="payout.adyen?.kyc_required"
                  size="mini"
                  type="primary"
                  label="Verify"
                  (click)="$event.stopPropagation()"
                  (clicked)="verifyClicked(payout.uuid)"></sbnb-button>
              </div>
            </div>

            <div class="mobile-second-row" fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
              <div fxFlex>
                <span class="text__small smoke-darker">
                  {{ payout.provider === 'adyen' ? 'Direct Premium' : 'Direct Basic' }}
                </span>
              </div>

              <div>
                <sbnb-direct-payout-method-status
                  [payout]="payout"
                  (verificationClicked)="verifyClicked(payout.uuid)"></sbnb-direct-payout-method-status>
              </div>
            </div>

            <div class="mobile-third-row" fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
              <sbnb-avatar-group
                [items]="payout.property_list"
                [allItems]="payout.all_properties"
                [itemsForLabel]="payout | payoutMethodTitle"
                allItemsLabel="Default"></sbnb-avatar-group>
            </div>
          </a>
        </ng-template>
      </div>
    </ng-container>

    <ng-template #loading>
      <mat-spinner [diameter]="32"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
